import { render } from "./bilibili-crop-request.vue?vue&type=template&id=67ccf4a2&ts=true"
import script from "./bilibili-crop-request.vue?vue&type=script&lang=ts"
export * from "./bilibili-crop-request.vue?vue&type=script&lang=ts"

import exportComponent from "/srv/bimgx-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__